/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountServer = void 0;
var json_proto_serializer_1 = require("@wix/json-proto-serializer");
var http_1 = require("@wix/ambassador/runtime/http");
var AccountServer = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        AccountBackOfficeService: function () {
            return function (headers) {
                var service = {
                    bulkGetParentAccountData: function (bulkGetParentAccountIdsRequest) {
                        return httpClient.invoke('POST', '/v1/bo/accounts/parent', bulkGetParentAccountIdsRequest, headers);
                    },
                    changeAccountOwner: function (changeAccountOwnerRequest) {
                        return httpClient.invoke('POST', '/v1/bo/accounts/{accountId}/change-owner', changeAccountOwnerRequest, headers);
                    },
                    changeAccountStatus: function (changeAccountStatusRequest) {
                        return httpClient.invoke('POST', '/v1/bo/accounts/{accountId}/changeStatus', changeAccountStatusRequest, headers);
                    },
                    getActiveUserAccounts: function (getUserAccountsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v1/bo/users/{userId}/accounts/active', getUserAccountsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['accounts', 'dateCreated'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['accounts', 'dateUpdated'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getUserAccounts: function (getUserAccountsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v1/bo/users/{userId}/accounts', getUserAccountsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['accounts', 'dateCreated'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['accounts', 'dateUpdated'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.bulkGetParentAccountData.__http_method = 'POST';
                service.bulkGetParentAccountData.__http_url = '/v1/bo/accounts/parent';
                service.changeAccountOwner.__http_method = 'POST';
                service.changeAccountOwner.__http_url = '/v1/bo/accounts/{accountId}/change-owner';
                service.changeAccountStatus.__http_method = 'POST';
                service.changeAccountStatus.__http_url = '/v1/bo/accounts/{accountId}/changeStatus';
                service.getActiveUserAccounts.__http_method = 'GET';
                service.getActiveUserAccounts.__http_url = '/v1/bo/users/{userId}/accounts/active';
                service.getUserAccounts.__http_method = 'GET';
                service.getUserAccounts.__http_url = '/v1/bo/users/{userId}/accounts';
                return service;
            };
        },
        AccountService: function () {
            return function (headers) {
                var service = {
                    createAccount: function (createAccountRequest) {
                        return httpClient.invoke('POST', '/v1/accounts/create', createAccountRequest, headers);
                    },
                    createAccountAndAssignUser: function (createAccountAndAssignUserRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v1/accounts/{user_id}', createAccountAndAssignUserRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['account', 'dateCreated'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['account', 'dateUpdated'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    createAccountForMyUser: function (createAccountForMyUserRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v1/accounts', createAccountForMyUserRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['account', 'dateCreated'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['account', 'dateUpdated'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    createAccountTenant: function (createAccountTenantRequest) {
                        return httpClient.invoke('POST', '/v1/accounts/create_tenant', createAccountTenantRequest, headers);
                    },
                    deleteAccount: function (deleteAccountRequest) {
                        return httpClient.invoke('DELETE', '/v1/accounts/{accountId}', deleteAccountRequest, headers);
                    },
                    getAccount: function (getAccountRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v1/accounts/{accountId}', getAccountRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['account', 'dateCreated'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['account', 'dateUpdated'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getAccounts: function (getAccountsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v1/accounts', getAccountsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['accounts', 'dateCreated'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['accounts', 'dateUpdated'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getMyAccount: function (getMyAccountRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v1/accounts/my_account', getMyAccountRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['account', 'dateCreated'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['account', 'dateUpdated'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getMyUserAccounts: function (getMyUserAccountsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v1/users/my_accounts', getMyUserAccountsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['accounts', 'dateCreated'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['accounts', 'dateUpdated'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getParentAccountInfo: function (getParentAccountInfoRequest) {
                        return httpClient.invoke('GET', '/v1/accounts/parent/info', getParentAccountInfoRequest, headers);
                    },
                    getSubAccounts: function (getSubAccountsRequest) {
                        return httpClient.invoke('GET', '/v1/accounts/sub_accounts', getSubAccountsRequest, headers);
                    },
                    getUserAccount: function (getUserAccountRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v1/users/{userId}/account', getUserAccountRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['dateCreated'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['dateUpdated'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getUserAccounts: function (getUserAccountsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v1/users/{userId}/accounts', getUserAccountsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['accounts', 'dateCreated'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['accounts', 'dateUpdated'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    isTeam: function (isTeamRequest) { return httpClient.invoke('GET', '/v1/accounts/{accountId}/team', isTeamRequest, headers); },
                    listChildAccounts: function (listChildAccountsRequest) {
                        return httpClient.invoke('GET', '/v1/account/child-accounts', listChildAccountsRequest, headers);
                    },
                    markAccountFlag: function (markAccountFlagRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('PATCH', '/v1/accounts/{accountId}/flags', markAccountFlagRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['account', 'dateCreated'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['account', 'dateUpdated'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    setIsReadOnlyAccount: function (setIsReadOnlyAccountRequest) {
                        return httpClient.invoke('PATCH', '/v1/accounts/{accountId}/is_read_only', setIsReadOnlyAccountRequest, headers);
                    },
                    updateAccount: function (updateAccountRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('PATCH', '/v1/accounts/{accountId}', updateAccountRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['account', 'dateCreated'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['account', 'dateUpdated'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    updateParentAccount: function (updateParentAccountRequest) {
                        return httpClient.invoke('PATCH', '/v1/accounts/parent', updateParentAccountRequest, headers);
                    },
                    updateSlugName: function (updateSlugRequest) { return httpClient.invoke('PATCH', '/v1/accounts/{accountId}/slug', updateSlugRequest, headers); },
                };
                service.createAccount.__http_method = 'POST';
                service.createAccount.__http_url = '/v1/accounts/create';
                service.createAccountAndAssignUser.__http_method = 'POST';
                service.createAccountAndAssignUser.__http_url = '/v1/accounts/{user_id}';
                service.createAccountForMyUser.__http_method = 'POST';
                service.createAccountForMyUser.__http_url = '/v1/accounts';
                service.createAccountTenant.__http_method = 'POST';
                service.createAccountTenant.__http_url = '/v1/accounts/create_tenant';
                service.deleteAccount.__http_method = 'DELETE';
                service.deleteAccount.__http_url = '/v1/accounts/{accountId}';
                service.getAccount.__http_method = 'GET';
                service.getAccount.__http_url = '/v1/accounts/{accountId}';
                service.getAccounts.__http_method = 'GET';
                service.getAccounts.__http_url = '/v1/accounts';
                service.getMyAccount.__http_method = 'GET';
                service.getMyAccount.__http_url = '/v1/accounts/my_account';
                service.getMyUserAccounts.__http_method = 'GET';
                service.getMyUserAccounts.__http_url = '/v1/users/my_accounts';
                service.getParentAccountInfo.__http_method = 'GET';
                service.getParentAccountInfo.__http_url = '/v1/accounts/parent/info';
                service.getSubAccounts.__http_method = 'GET';
                service.getSubAccounts.__http_url = '/v1/accounts/sub_accounts';
                service.getUserAccount.__http_method = 'GET';
                service.getUserAccount.__http_url = '/v1/users/{userId}/account';
                service.getUserAccounts.__http_method = 'GET';
                service.getUserAccounts.__http_url = '/v1/users/{userId}/accounts';
                service.isTeam.__http_method = 'GET';
                service.isTeam.__http_url = '/v1/accounts/{accountId}/team';
                service.listChildAccounts.__http_method = 'GET';
                service.listChildAccounts.__http_url = '/v1/account/child-accounts';
                service.markAccountFlag.__http_method = 'PATCH';
                service.markAccountFlag.__http_url = '/v1/accounts/{accountId}/flags';
                service.setIsReadOnlyAccount.__http_method = 'PATCH';
                service.setIsReadOnlyAccount.__http_url = '/v1/accounts/{accountId}/is_read_only';
                service.updateAccount.__http_method = 'PATCH';
                service.updateAccount.__http_url = '/v1/accounts/{accountId}';
                service.updateParentAccount.__http_method = 'PATCH';
                service.updateParentAccount.__http_url = '/v1/accounts/parent';
                service.updateSlugName.__http_method = 'PATCH';
                service.updateSlugName.__http_url = '/v1/accounts/{accountId}/slug';
                return service;
            };
        },
        TeamService: function () {
            return function (headers) {
                var service = {
                    assignUserToTeam: function (assignUserToTeamRequest) { return httpClient.invoke('POST', '/v1/team', assignUserToTeamRequest, headers); },
                    getTeamMember: function (getTeamMemberRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v1/team/members', getTeamMemberRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['user', 'joinedAt'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    listTeamMembers: function (listTeamMembersRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v1/team', listTeamMembersRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['users', 'joinedAt'] },
                                        { typeName: 'int64', pathInPayload: ['totalUsersInAccount'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    listTeamMembersIds: function (listTeamMembersIdsRequest) {
                        return httpClient.invoke('GET', '/v1/accounts/{accountId}/ids', listTeamMembersIdsRequest, headers);
                    },
                    removeTeamMember: function (removeTeamMemberRequest) {
                        return httpClient.invoke('DELETE', '/v1/team/{userId}', removeTeamMemberRequest, headers);
                    },
                };
                service.assignUserToTeam.__http_method = 'POST';
                service.assignUserToTeam.__http_url = '/v1/team';
                service.getTeamMember.__http_method = 'GET';
                service.getTeamMember.__http_url = '/v1/team/members';
                service.listTeamMembers.__http_method = 'GET';
                service.listTeamMembers.__http_url = '/v1/team';
                service.listTeamMembersIds.__http_method = 'GET';
                service.listTeamMembersIds.__http_url = '/v1/accounts/{accountId}/ids';
                service.removeTeamMember.__http_method = 'DELETE';
                service.removeTeamMember.__http_url = '/v1/team/{userId}';
                return service;
            };
        },
    };
};
exports.AccountServer = AccountServer;
exports.AccountServer.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map